import { render, staticRenderFns } from "./Acquisition.html?vue&type=template&id=47b7dc32&"
import script from "./Acquisition.js?vue&type=script&lang=js&"
export * from "./Acquisition.js?vue&type=script&lang=js&"
import style0 from "./Acquisition.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports